module.exports = __webpack_public_path__ + "img/fresh-fruits.cad48a0d.jpg";